<template>
    <div>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li>产品介绍</li>
                <li>400选号</li>
            </ul>
        </div>
        <div class="mainindex">
            <div class="welinfo">
                <div style="text-align:center;">
                    <strong style="font-size: 18px;color:rgb(100, 164, 248)">400电话 800电话</strong>
                    <label style="font-size: 18px;color:red;margin-left:10px;">超省钱的电话中心</label>
                    <el-button type="danger" style="margin-left:15px;letter-spacing: 1px;" @click="open400()" >马上开通400</el-button>
                </div>
                <ul class="infolist">
                    <div style="text-align:left;">
                    <label style="font-size: 12px;color:red;margin-left:10px;">轻松升级客服,立显专业形象</label>
                        <br>
                        <label style="font-size: 12px;color:red;margin-left:10px;">认得每个来电，不再对老客户说 “喂”</label>
                        <br>
                        <label style="font-size: 12px;color:red;margin-left:10px;">2010 促销:400直拨号月最低消费降至30元起，免选号费，免月租，每分钱都是话费, 400不比装个固话贵</label>
                    </div>
                    <li>
                        <b style="font-size: 13px;">1. 总机型</b>
                        <label style="color:coral;">（适用一般小型店铺 ，使用量不大的中小企业或个人SOHO）</label>
                    </li>
                    <li>
                        <span style="margin-left: 20px;">（1）最低消费（默认套餐）：软件免月租，每天最低消费0.15元，资费0.15元/分钟起</span>
                    </li>
                    <li>
                        <span style="margin-left: 20px;">（2）VIP： 可享受更优惠的资费，适合电话量大的用户</span>
                    </li>
                    <li>
                        <b style="font-size: 13px;">2. 400直拨号</b>
                        <label style="color:coral;">（更方便拨打，形象更高端，费用更低）</label>
                    </li>
                    <li>
                        <span style="margin-left: 20px;">
                            <b>最低消费型：</b>月或天有最低消费额，每号不同; 适合要求更高，电话量大的用户。最低消费30元/月起
                        </span>
                    </li>
                    <li><b style="font-size: 13px;">3. 网页800电话链接</b></li>
                    <li>
                        <span style="margin-left: 20px;">
                        用户轻松在自己的网站、网店、宣传页面发布电话链接，客户完全免费
                        </span>
                    </li>
                    <li style="clear:both;"><b style="font-size: 13px;">4. 附加增值功能</b></li>
                    <li>
                        <span style="margin-left: 20px;">
                            如个性彩铃、来电弹屏，来电管理，语音导航等
                        </span>
                    </li>
                    <li style="clear:both;"><b style="font-size: 13px;">4. 后续服务，伴您成长</b></li>
                    <li>
                        <span style="margin-left: 20px;">
                            （1）不仅提供400，800电话号码，更可为您的将来后续成长
                        </span>
                    </li>
                    <li>
                        <span style="margin-left: 20px;">
                            （2）提供配套的一站式呼叫服务中心，伴您前行
                        </span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="xline"></div>
        <div class="mainindex">
            <div class="welinfo">
            <div style="text-align:center;"><strong style="font-size: 18px;color:rgb(100, 164, 248); ">拥有400/800电话，生意更方便, 用户更信任</strong></div>
                <ul class="infolist">
                    <div style="text-align:left;">
                        <label style="font-size: 12px;color:red;margin-left:10px;">小钱办大事 方便客户 增加商机</label>
                        <br>
                        <label style="font-size: 12px;color:red;margin-left:10px;">超低的资费，使小企业也有了大形象</label>
                    </div>
                    <li>
                        <el-tooltip class="item" effect="dark" content="点击开通400" placement="right">
                            <b style="font-size: 18px;background-color: coral;color:white;cursor: pointer;" @click="open400()">400在线选号平台：立即选号，马上申请，快速开通&nbsp;&nbsp;</b>
                        </el-tooltip>
                    </li>
                    <li><span style="margin-left: 20px;">在线选号:查找号码栏, 可以输入任意你想要包含的号码; 号码选取好后，请尽快和客服联络，进行预占，准备开通材料(工商营业执照（复印，盖红章后扫描成电子版），法人及经办人身份证), 以免号码被抢占</span></li>
                </ul>
            </div>
        </div>
        <div class="xline"></div>
    </div>
</template>

<script>
export default {
    methods:{
        open400() {
            window.open('http://4006.2office.cn/lkszjreo/wqi4rpo/ewirwed/qncyrq/oijoijfkiej.aspx', '800', '600');
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/shouye/productdescription/400phoneintroduction.vue